import request from "@/utils/request";

// 获取首页数据
export const bigScreenIndex = (params) =>
  request({
    url: "/bigScreen/bigScreenIndex",
    method: "POST",
    data: params,
  });

// 获取首页表格数据
export const bigScreenIndex2 = (params) =>
  request({
    url: "/bigScreen/bigScreenIndex2",
    method: "POST",
    data: params,
  });
